import Vue from 'vue'

import Storage from '@/utils/storage'
import { setBaseURL } from '@/utils/request'

import 'normalize.css/normalize.css' // a modern alternative to CSS resets

import Element from 'element-ui'
import './styles/element-variables.scss'
// import enLang from 'element-ui/lib/locale/lang/en'// 如果使用中文语言包请默认支持，无需额外引入，请删除该依赖

import '@/styles/tailwind.css' // tailwind css
import '@/styles/index.scss' // global css

import App from './App'
import store from './store'
import router from './router'

import './icons' // icon
import './permission' // permission control
import './utils/error-log' // error log

import * as filters from './filters' // global filters

import components from './components'
Vue.use(components)

/**
 * If you don't want to use mock-server
 * you want to use MockJs for mock api
 * you can execute: mockXHR()
 *
 * Currently MockJs will be used in the production environment,
 * please remove it before going online ! ! !
 */
// console.log(process.env.NODE_ENV, process.env);
/* if (process.env.NODE_ENV === 'production') {
  const { mockXHR } = require('../mock')
  mockXHR()
} */

Vue.use(Element, {
  size: Storage.get('size') || 'medium', // set element-ui default size
  // locale: enLang // 如果使用中文，无需设置，请删除
})

// register global utility filters
Object.keys(filters).forEach(key => {
  Vue.filter(key, filters[key])
})

Vue.config.productionTip = false

// 启动时恢复用户选择的站点API作为全局BASE URL
const selectedWebsite = Storage.get('SelectedWebsite')
if (selectedWebsite?.api) {
  setBaseURL(selectedWebsite.api)
}

new Vue({
  el: '#app',
  router,
  store,
  render: h => h(App),
})
